export default {
    activities_tab_title: 'Actividades',
    activities_tab_controller: 'Controlador',
    activities_tab_action: 'Acción',
    activities_tab_created_at: 'Creado En',
    activities_tab_type: 'Tipo',
    activities_tab_change: 'Cambio',
    activities_tab_created_by: 'Creado Por',
    activities_tab_search_by_controller: 'Búsqueda por controlador',
    activities_tab_show_change: 'Mostrar el cambio',
    activities_tab_platform: 'Plataforma',
    activities_tab_method: 'Método',
    activities_tab_username: "Usuario",
    activities_tab_title_vidfleet_compare: "Cambios en la Configuración",
    activities_tab_entity_id: "Id de la Entidad",
    activities_tab_url: "Url",
    activities_tab_no_changes: "Sin cambios"
};